import { FilterBar, FormGroup, Label, TextField, Select } from '@celltrak/ui-components';

import { statusFilterOptions, text } from '../../constants';

import useVisitFilterBar from './hooks';

function VisitsFilterBar() {
  const {
    partnersOptions,
    aggregatorsOptions,
    agencyOptions,
    handleFilterChanges,
    handleResetFilter,
    handleEnterPress,
    filters,
    handleApply,
    disableApplyButton,
    disableResetButton,
  } = useVisitFilterBar();

  return (
    <FilterBar
      onSecondaryClick={handleResetFilter}
      onPrimaryClick={handleApply}
      buttonSize="sm"
      disableSecondaryButton={disableResetButton}
      secondaryButtonLabel={text.visitFilterBar.reset}
      primaryButtonLabel={text.visitFilterBar.apply}
      disablePrimaryButton={disableApplyButton}
    >
      <FormGroup>
        <Label for="date-start-filter" size="sm">
          Start Date
        </Label>
        <TextField
          id="date-start-filter"
          size="sm"
          placeholder="YYYY-MM-DD"
          value={filters.receivedOnStartDate}
          onChange={handleFilterChanges('receivedOnStartDate')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
      <FormGroup>
        <Label for="date-end-filter" size="sm">
          End Date
        </Label>
        <TextField
          id="date-end-filter"
          size="sm"
          placeholder="YYYY-MM-DD"
          value={filters.receivedOnEndDate}
          onChange={handleFilterChanges('receivedOnEndDate')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
      <FormGroup>
        <Label for="visit-id-filter" size="sm">
          Visit ID
        </Label>
        <TextField
          id="visit-id-filter"
          size="sm"
          placeholder="Search..."
          value={filters.visitID}
          onChange={handleFilterChanges('visitID')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
      <FormGroup>
        <Label for="partner-filter" size="sm">
          Partner
        </Label>
        <Select
          id="partner-filter"
          size="sm"
          options={partnersOptions}
          value={filters.partnerID}
          onChange={handleFilterChanges('partnerID')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="agency-filter" size="sm">
          Agency
        </Label>
        <Select
          id="agency-filter"
          size="sm"
          options={agencyOptions}
          value={filters.agencyID}
          onChange={handleFilterChanges('agencyID')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="status-filter" size="sm">
          Status
        </Label>
        <Select
          id="status-filter"
          size="sm"
          options={statusFilterOptions}
          value={filters.status}
          onChange={handleFilterChanges('status')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="node-filter" size="sm">
          Node
        </Label>
        <Select
          id="node-filter"
          size="sm"
          options={aggregatorsOptions}
          value={filters.aggregatorID}
          onChange={handleFilterChanges('aggregatorID')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="reference-number-filter" size="sm">
          Reference Number
        </Label>
        <TextField
          id="reference-number-filter"
          size="sm"
          placeholder="Search..."
          value={filters.originalReferenceNumber}
          onChange={handleFilterChanges('originalReferenceNumber')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
    </FilterBar>
  );
}

export default VisitsFilterBar;
